import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.875 4.37496L3.03375 8.21621C2.4815 8.76846 2.4815 9.66396 3.03375 10.2162C3.586 10.7685 4.4815 10.7685 5.03375 10.2162L9.79425 5.45571C10.7262 4.52371 10.7262 3.01271 9.79425 2.08071C8.86225 1.14871 7.35125 1.14871 6.41925 2.08071L1.375 7.12496"
          stroke="#7A8499"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
